import meridianTypes from './meridian.types';

export const getMeridianClientsAction = (payload, cb, cbError) => ({
  type: meridianTypes.GET_MERIDIAN_CLIENTS,
  payload,
  cb,
  cbError
});

export const getMeridianClientDetailsAction = (payload, cb, cbError) => ({
  type: meridianTypes.GET_MERIDIAN_CLIENT_DETAILS,
  payload,
  cb,
  cbError
});

export const activateMeridianClientAction = (payload, cb, cbError) => ({
  type: meridianTypes.ACTIVATE_MERIDIAN_CLIENT,
  payload,
  cb,
  cbError
});
